import { Record } from 'immutable';

import { DashboardListEntity } from '../components/dashboard-list/dashboard-list.entity';

export const DashboardSliceKey = 'main';

export interface IDashboardMainSliceState {
	loading: boolean;
	list: DashboardListEntity;
	includePublicProjects: boolean;
	deleteSuccess: boolean;
}

export const defaults: IDashboardMainSliceState = {
	loading: false,
	list: DashboardListEntity.build([]),
	includePublicProjects: false,
	deleteSuccess: false,
};

export class DashboardMainSliceState extends Record<IDashboardMainSliceState>(
	defaults
) {
	public static readonly key = DashboardSliceKey;

	public setLoading(isLoading: boolean): DashboardMainSliceState {
		return this.set('loading', isLoading);
	}

	public setDeleteSuccess(isSuccess: boolean): DashboardMainSliceState {
		return this.set('deleteSuccess', isSuccess);
	}

	public setDashboardList(
		dashboardList: DashboardListEntity
	): DashboardMainSliceState {
		return this.set('list', dashboardList);
	}

	public toggleIncludePublicProjects(
		includePublicProjects: boolean
	): DashboardMainSliceState {
		return this.set('includePublicProjects', includePublicProjects);
	}
}
